<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
            <div class="topImgTitle">我的诉求</div>
            <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
            </div>
        </div>
        <div class="a_dataContent">
            <div class="a_listContent e-flex" v-for="(item, index) in list" v-if="index % 2 == 0">
                <div class="a_listBlock" @click="goDetail(item.id)">
                    <div class="a_listTitle e-line-1">企业人才诉求表单</div>
                    <div class="a_listDate">提交时间：{{ item.createDate.slice(0,16) }}</div>
                </div>
                <div class="a_listBlock a_listBlock_ml20" v-if="list[index + 1]" @click="goDetail(list[index + 1].id)">
                    <div class="a_listTitle e-line-1">企业人才诉求表单</div>
                    <div class="a_listDate">提交时间：{{ list[index + 1].createDate.slice(0,16) }}</div>
                </div>
            </div>
            <div class="noDataContent" v-if="list.length == 0">
              <img class="noDataImg" src="@/assets/images/noDataImg.png">
              <div class="noDataText">暂无内容</div>
            </div>
        </div>
        <div class="e-flex pd_paginationContent">
            <el-pagination background layout="prev, pager, next, jumper" :page-size="10" :total="recordsTotal" @current-change="pageChange"></el-pagination>
        </div>
    </div>
</template>
  
  <script>
    import '../../styles/appeal.css'
    export default {
      name: 'appeal',
      data () {
        return {
            page: 1,
            list: [],
            user: {},
            recordsTotal: 0
        }
      },
      created() {
        this.user = JSON.parse(localStorage.getItem('user'))
        this.getList()
      },
      methods: {
        pageChange() {
            this.page = e
        },
        goDetail(id) {
            this.$router.push({ path: '/appeal/appealDetail', query: {id: id}})
        },
        getList() {
            this.request({
              url: 'feedback/list',
              method: 'POST',
              data: {
                page:this.page,
                limit:10,
                userId: this.user.id ? this.user.id : this.user.data.id
              }
            }).then(res => {
                if (res.code == 1) {
                  this.list = res.data
                  this.recordsTotal = res.recordsTotal
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/appeal/index.vue